module.exports = __webpack_public_path__ + "img/t_2.7b091993.png";